import React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/25/thumb-landscape.jpg"

const Post25 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">Tory Burch／トートバッグ／34 x24 x11cm</span>   
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>2004年にニューヨークで創立以来、わずか数年で世界のトップブランドの仲間入りを果たしたTory Burch（トリーバーチ）。トリーバーチのバッグといえば、2つの『T』を対称にした印象的なブランドロゴを一度は見たことがあるという方も多いはず。今回はラクサスで人気のトリーバーチのバッグ10選をご紹介します！</p>
        </div>
      </div>
    </section>
    <div className="wrapper">
      <section className="bag-content">
        <div className="text-max-width">
          <h2>フレミング</h2>
          <p>繊細なダイヤモンド型キルティングが美しい「フレミング」。フェミニンなデザインとかっちりとしたフォルムがコーデに上品な甘さをプラスしてくれます。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/25/1.jpg" alt="" />
          </figure>          
          <figure className="img-small">
              <StaticImage src="../../images/posts/25/2.jpg" alt="" />
          </figure>
        </div>  
        <span className="text-center">Tory Burch／チェーンショルダーバッグ／26 x21 x9cm</span>                 
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/25/3.jpg" alt="" />
              <span className="text-center">Tory Burch／チェーンショルダーバッグ／23 x20 x7cm</span>      
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/25/4.jpg" alt="" />
              <span className="text-center">Tory Burch／チェーンショルダーバッグ／23 x19 x8cm</span>      
          </figure>
        </div>
        <div className="text-max-width">
          <h2>ロビンソン</h2>
          <p>上質なレザーにワンポイントのロゴが上品に映える「ロビンソン」。A4サイズも収納できるサイズ感とベーシックなデザインがお仕事バッグとして人気の高いアイテム。</p>          
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/25/5.jpg" alt="" />
          </figure>          
          <figure className="img-small">
              <StaticImage src="../../images/posts/25/6.jpg" alt="" />
          </figure>
        </div>        
        <span className="text-center">Tory Burch／トートバッグ／30 x23 x12cm</span>           
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/25/7.jpg" alt="" />
              <span className="text-center">Tory Burch／トートバッグ／30 x23 x12cm</span>           
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/25/8.jpg" alt="" />
              <span className="text-center">Tory Burch／トートバッグ／38 x23 x9cm</span>           
          </figure>
        </div>
        <div className="text-max-width">
          <h2>ミラー</h2>
          <p>レザーのロゴストラップがアイコニックな「ミラー」。デイリーに使いやすいキャンバス素材とちょっとしたお出かけにぴったりな程よいサイズ感が人気のアイテム。</p>
        </div>
        <div className="img-two-cloumn">
        <figure className="img-small">
              <StaticImage src="../../images/posts/25/9.jpg" alt="" />
            </figure>        
          <figure className="img-small">
              <StaticImage src="../../images/posts/25/10.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">Tory Burch／トートバッグ／39 x30 x14cm</span>       
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/25/11.jpg" alt="" />
              <span className="text-center">Tory Burch／ショルダーバッグ／20 x15 x5cm</span>     
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/25/12.jpg" alt="" />
              <span className="text-center">Tory Burch／ショルダーバッグ／19 x18 x6cm</span>     
          </figure>
        </div>        
        <div className="text-max-width">
          <h2>ハーフムーン</h2>
          <p>通常のロゴモチーフではなく、『T』が１つだけデザインされた「ハーフムーン」。ブランドを主張しすぎないシンプルなデザインは、よりコーデを上品に引き立たせてくれるはず。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/25/13.jpg" alt="" />
          </figure>          
          <figure className="img-small">
              <StaticImage src="../../images/posts/25/14.jpg" alt="" />
          </figure>
        </div>    
        <span className="text-center">Tory Burch／2WAYバッグ／35 x22 x13cm</span>    
        <div className="text-max-width">
          <h2>マックグロー</h2>
          <p>バッグ中央に施されたステッチが印象的な「マックグロー」。デイリーならクロスボディ、ナイトシーンではクラッチとして持つなど、シーンに応じて使い分けも可能。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/25/15.jpg" alt="" />
        </figure>
        <span className="text-center">Tory Burch／ショルダーウォレット／20 x13 x3cm</span>    
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/25/16.jpg" alt="" />
              <span className="text-center">Tory Burch／ショルダーウォレット／20 x13 x3cm</span>    
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/25/17.jpg" alt="" />
              <span className="text-center">Tory Burch／ショルダーバッグ／22 x15 x6cm</span>    
          </figure>
        </div>        
        <Link to="https://laxus.co/app/pc/bags/toryburch" className="view-all-button">
          トリーバーチのバッグを見る
        </Link>        
        <div className="text-max-width">
          <h2>ブロックT</h2>
          <p>「ケイト バッグ全体に施された『T』のステッチがスタイリッシュな「ブロックT」。フェミニンな服装にも合わせやすい高級感のあるデザインが魅力。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/25/18.jpg" alt="" />
          </figure>        
          <figure className="img-small">
              <StaticImage src="../../images/posts/25/19.jpg" alt="" />
          </figure>
        </div>      
        <span className="text-center">Tory Burch／トートバッグ／39 x28 x14cm</span>      
        <div className="text-max-width">
          <h2>キラ</h2>
          <p>太めのチェーンがインパクト抜群な「キラ」。シンプルながら存在感のあるデザインは、いつものカジュアルスタイルに合わせればこなれた印象に。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/25/20.jpg" alt="" />
          </figure>        
          <figure className="img-small">
              <StaticImage src="../../images/posts/25/21.jpg" alt="" />
          </figure>
        </div>  
        <span className="text-center">Tory Burch／ショルダーバッグ／18 x13 x7cm</span>            
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/25/22.jpg" alt="" />
              <span className="text-center">Tory Burch／ショルダーバッグ／16 x12 x5cm</span>            
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/25/23.jpg" alt="" />
              <span className="text-center">Tory Burch／ショルダーバッグ／18 x9 x3cm</span>            
          </figure>
        </div>
        <div className="text-max-width">
          <h2>ジェミニリンク</h2>
          <p>バッグ全面にデザインされた個性的なパターンが目をひく「ジェミニリンク」。コーティング加工されたキャンバス素材なので耐久性も抜群。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/25/24.jpg" alt="" />
          </figure>            
          <figure className="img-small">
            <StaticImage src="../../images/posts/25/25.jpg" alt="" />
          </figure>
        </div>   
        <span className="text-center">Tory Burch／2WAYバッグ／30 x25 x10cm</span>            
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/25/26.jpg" alt="" />
            <span className="text-center">Tory Burch／トートバッグ／38 x28 x14cm</span>        
          </figure>            
          <figure className="img-small">
            <StaticImage src="../../images/posts/25/27.jpg" alt="" />
            <span className="text-center">Tory Burch／2WAYバッグ／30 x25 x10cm</span>        
          </figure>
        </div>
        <div className="text-max-width">
          <h2>エラ</h2>
          <p>丈夫で汚れに強いナイロン素材で作られた「エラ」。大きめのサイズ感と肩にかけやすい長めのハンドルは日常使いにぴったり。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/25/28.jpg" alt="" />
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/25/29.jpg" alt="" />
          </figure>
        </div>  
        <span className="text-center">Tory Burch／トートバッグ／34 x26 x9cm</span>                
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/25/30.jpg" alt="" />
            <span className="text-center">Tory Burch／ハンドバッグ／33 x24 x8cm</span>         
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/25/31.jpg" alt="" />
              <span className="text-center">Tory Burch／トートバッグ／35 x25 x10cm</span>         
          </figure>
        </div>
        <div className="text-max-width">
          <h2>ティルダ</h2>
          <p>スポーティーなデザインが魅力の「ティルダ」はカジュアルスタイルと相性抜群。丈夫で軽く、底マチの幅も広いので必需品をすっきりと収納できます。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/25/32.jpg" alt="" />
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/25/33.jpg" alt="" />
              <span className="text-center">24x34x13cm</span>
          </figure>
        </div>
        <span className="text-center">Tory Burch／バックパック／24 x34 x13cm</span>     
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/25/34.jpg" alt="" />
            <span className="text-center">Tory Burch／バックパック／23 x25 x10cm</span>     
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/25/35.jpg" alt="" />
              <span className="text-center">Tory Burch／バックパック／28 x37 x10cm</span>     
          </figure>
        </div>                               
        <div className="text-two-cloumn">
          <h2>バリエーション豊富な<br className="pc"></br>トリーバーチのバッグ</h2>
          <p>デザインのバリエーションが豊富なトリーバーチのバッグは、ビジネス・カジュアル・パーティーシーンまで用途に応じて選びやすいのが魅力。ラクサスでも多数扱っていますので、ぜひオシャレの参考に覗いてみてくださいね♪</p>
        </div>                          
        <Link to="https://laxus.co/app/pc/bags/toryburch" className="view-all-button">
          トリーバーチのバッグを見る
        </Link>                
      </section>
      <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post25

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 25}) {
      id
      title
      description
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
